export const Features = {
	task: 1105,
	taskStatus: 110502,
	taskType: 110501,
	user: 4002,
	userFormalization: 400202,
	userProfile: 4001,
	account: 4005,
	accountStatus: 400502,
	partner: 1113,
	partnerStatus: 111302,
	broker: 1008,
	brokerStatus: 100802,
	store: 1007,
	storeStatus: 100702,
	customer: 1006,
	customerStatus: 100602,
	hierarchy: 4022,
	status: 1033,
	setting: 1033,
	queue: 1212,
	notification: 1063,
	queryPerson: 5020,
	queryCompany: 5021,
	queryHistory: 5019,
	admin: 4006,
	language: 1116,
	enrichment: 5022,
	credit: 4025,
	ajinData: 8000,
	ajinPonto: 8002,
	marketplace: 1121,
	invoice: 1012,
	license: 4003,
	licensePlan: 4004,
	group: 1001,
	groupItem: 100101,
	financeAccount: 1200,
	financePosting: 1202,
	financePostingFilterDashboard: 120201,
	financePostingFilterCardInvoice: 120202,
	financePostingFilterConciliation: 120203,
	financePostingFilterReport: 120204,
	category: 1201,
	categoryGroup: 120101,
	categoryGroupStatus: 1201,
	categoryStatus: 120101,
	cardInvoice: 1203,
	cardInvoiceFilterDashboard: 120301,
	openFinance: 1204,
	openFinanceTransaction: 1205,
	businessUnit: 1206,
	businessUnitItem: 120601,
	approval: 1207,
	approvalRule: 120701,
	apportionmentOfCost: 2208,
	counterParty: 2209,
	charge: 1118,
	chargeStatus: 111802,

	link: 1131,
	linkHistory: 113101,
	linkStatus: 113102,
	queryInss: 1131,
	coupon: 1124,
	couponHistory: 112401,
	order: 1119,
	payment: 1122,
	mailing: 6050,
	punch: 1126,
	workSchedule: 1127,
	workScheduleStatus: 112702,
	workScheduleModel: 1128,
	workScheduleModelStatus: 112802,
	employee: 1125,
	employeeStatus: 112502,
	punchDevice: 1129,
	punchClosure: 1130,
	costCenter: 1204,
	costCenterStatus: 113401,
	loan: 1010,
	loanProduct: 101001,
	loanStatus: 101002,
	loanSimulation: 1136,
	export: 1089,
	import: 1139,
	loanAssignmentData: 1161,
	portabilityRetention: 1217,
	portabilityRetentionStatus: 121701,
	loanDailyFilters: 101011,
	loanResubmissionPaymentFilter: 101012,
	loanDashboardFilter: 101013,
	loanPendingFilter: 101014,
	loanBatchApprovalFilter: 101028,
	lender: 1021,
	lenderStatus: 1021001,
	timeOff: 1141,
	loanSimulationBatch: 1143,
	queryInssBalance: 5040,
	queryInssBalanceBatch: 5041,
	queryFgtsBalance: 5042,
	queryFgtsBalanceBatch: 5044,
	inssStatements: 5046,
	queryMilitaryPayrollBalance: 5048,
	queryPublicPayrollBalance: 5053,
	userRestriction: 4021,
	blackList: 1090,
	allowance: 9541,
	contractImportBatch: 1148,
	contractImportItem: 1149,
	portabilityEligibilityIntelligence: 1158,
	queryPrivatePayrollBalance: 5043,
	signature: 1135,
	eventTrigger: 1214,
	event: 1215,
	featureLimiter: 1216,
	featureLimiterItem: 121601,
	featureLimiterConversion: 121602,
	uy3: 9510,
	afterSale: 1154,
	webhook: 1133,
	loanPrivatePayrollConciliation: 101025,
	loanPrivatePayrollAuctionProposal: 101026,

	worker: 1220,
	workerJob: 122001,
	workerInstance: 122002,
	workerConfiguration: 122003,
	workerProcess: 122004,
	workerMachine: 122005,



	//Providers
	confia: 9501,
	confiaFgts: 950101,
	confiaPrivatePayroll: 950102,
	confiaSemearInss: 950103,
	qiTechFgts: 950001,
	qiTechDtvmFgts: 95000103,
	qiTechFgtsPayment: 95000104,
	qiTechPrivatePayroll: 950002,
	qiTechPrivatePayrollSandBox: 950002999,
	qiTechInss: 950004,
	qiTechInssRefin: 95000401,
	qiTechCardInss: 950005,
	qiTechSignExternal: 950006,
	qiTechSignInternal: 95000601,
	qiTechSiape: 950007,
	qiTechMilitaryPayroll: 950008,
	qiTechVehicleWarranty: 950009,
	inbursa: 9502,
	inbursaInss: 950201,
	inbursaPrivatePayroll: 950202,
	bank321Fgts: 950701,
	bank321Inss: 950702,
	bank321PrivatePayroll: 950703,
	j17Fgts: 950801,
	uy3PrivatePayroll: 951001,
	valorFinanciamentosInss: 951101,
	paranaCardInss: 951201,
	paranaPrivatePayroll: 951202,
	celCoinPrivatePayroll: 950601,
	lecca: 9513,
	leccaInss: 951301,



	inssQuerySimulation: 5047,
	queryPersonalData: 5055,
	ruleSet: 4027,
	seguros180: 9514,
	bmp: 9515,
	bmpPrivatePayroll: 951501,
	btg: 9516,
	btgPrivatePayroll: 951601,
	ukamBaasPrivatePayroll: 951801,
	ukamBaasPublicPayroll: 951802,
	peakSiape: 951701,
	bancoPaulista: 9519,
	infoSimplesFederalRevenuePj: 9520,
	lemitPersonalData: 9521,
	nexaiqCompanyData: 9522,
	boaVistaScoreBankruptcy: 9523,
	nortix: 9524,
	poligonoCapital: 9525,
	poligonoCapitalPrivatePayroll: 952501,
	solvera: 9527,
	cabure: 9528,
	semear: 9533,
	semearInss: 953301,
	smartinTech: 9534,
	guardianCreditEngine: 9535,
	smartnx: 9538,
	soma: 9539,
	somaPrivatePayroll: 953901,

	ukamFlow: 1221,
	ukamFlowSet: 1222,
};
